import React, { useEffect, useRef, useState } from 'react';
import { ButtonMenuView, ButtonMenuViewProps } from './ButtonMenu.view';
import { HoverEventEnum, useOnMouseHover } from '../../../hooks/useOnMouseHover';

export type ButtonMenuControllerProps = Omit<
  ButtonMenuViewProps,
  'open' | 'setOpen' | 'handleClickOutsideComponent' | 'portalElementRef'
> & {
  closeOnMouseOut?: boolean;
  openOnMouseOver?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
};

export const ButtonMenuController = (props: ButtonMenuControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const { onMenuShowEventCallback, onOpenChange } = props;
  const [open, setOpen] = useState<boolean>(false);
  const portalElementRef = useRef<HTMLDivElement | null>(null);
  const buttonMenuRef = useRef<HTMLDivElement | null>(null);

  const handleMouseOverComponent = () => {
    if (!open && props.openOnMouseOver) {
      setOpen(true);

      if (onMenuShowEventCallback) onMenuShowEventCallback(true);
    }
  };

  const handleMouseOutComponent = (event: MouseEvent) => {
    if (open && props.closeOnMouseOut) {
      if (
        buttonMenuRef.current &&
        !buttonMenuRef.current.contains(event.target as Node) &&
        portalElementRef.current &&
        !portalElementRef.current.contains(event.target as Node)
      ) {
        setOpen(false);

        if (onMenuShowEventCallback) onMenuShowEventCallback(false);
      }
    }
  };

  const handleClickOutsideComponent = () => {
    if (open) {
      setOpen(false);

      if (onMenuShowEventCallback) onMenuShowEventCallback(false);
    }
  };

  useOnMouseHover(buttonMenuRef, handleMouseOutComponent, HoverEventEnum.out);
  useOnMouseHover(buttonMenuRef, handleMouseOverComponent, HoverEventEnum.over);

  useEffect(() => {
    if (onOpenChange) {
      onOpenChange(open);
    }
  }, [open, onOpenChange]);

  const viewProps = { ...props, open, setOpen, handleClickOutsideComponent, portalElementRef };
  return <ButtonMenuView {...(viewProps as ButtonMenuViewProps)} ref={buttonMenuRef} />;
};
